import styled from 'styled-components';
import {
  device
} from '../../utils';

export const Wrapper = styled.div `
  display: block;
  overflow-x: auto;
  white-space: nowrap;

  margin: 0 -20px;

  @media (hover: hover) {
    margin: 0;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;


export const Table = styled.table `
  width: 100%;
  height: 1px;
  table-layout: fixed;
  /* border-collapse: collapse; */
  border-spacing: 0;

  --header-padding: 8px;

  th {
    position: relative;
    vertical-align: top;

    &:first-child {
      width: calc((100vw - var(--scrollbar-width) - 40px) * 35 / 100);
    }

    &:nth-child(n+2) {
      width: calc((100vw - var(--scrollbar-width) - 40px)  * 55 / 100);
    }
  }

  @media ${device.tabletDown} {
    &.child-1 {
      padding: 0 20px;
    }
  }

  @media ${device.tablet} {
    --table-columns: 3.2;
    --header-padding: 10px;

    th:nth-child(n) {
      width: calc(((min(1440px, (100vw - var(--scrollbar-width))) - 40px) / var(--table-columns)));
      box-sizing: border-box;
    }
  }

  @media ${device.laptop} {
    --table-columns: 4;
    --header-padding: 20px;
    width: auto;
  }

  @media ${device.laptopM} {
    --table-columns: 5;
  }

  th {
    box-sizing: border-box;
  }

  td, th {
    white-space: normal;
    height: 100%;

    &.red-border {
      border-left: 5px solid #C80F05 ;
      border-right: 5px solid #C80F05 ;
    }
  }

  tr {
    &:last-child {
      td {
        &.red-border {
          border-bottom: 5px solid #C80F05;
        }
      }
    }
  }

  td, th {
    &.fixed {
      position: sticky;
      left: 0;
      background: #FFF;
      z-index: 10;
    }

    /* @media ${device.tablet} {
      max-width: 25vw;
    } */
  }

  th {
    position: relative;
    padding: 30px calc(var(--header-padding) + 5px) 0px;

    &.red-border {
      padding: 30px var(--header-padding) 0px;
    }

    @media ${device.laptop} {
      padding: 30px calc(var(--header-padding) + 5px);

      &.red-border {
        padding: 30px var(--header-padding);
      } 

      &, &.red-border {
        padding-bottom: 0px;
      }
    }

    .product {
      text-align: left;
      height: 100%;

      .category {
        display: none;
      }
    }
  }
  
  td {

  }

  tbody {
    
  }

  tbody {
    td {
      border: none;
      padding: 15px 15px;
      border-top: 1px solid #D3D5D9;
      border-right: 1px solid #D3D5D9;

      &:first-child {
        border-left: 1px solid #D3D5D9;
      }

      &.highlight {
        background: #FDF5ED;
      }

      .simple-link {
        display: inline-block;
        margin-top: 5px;
      }

      &, p, p a {
        font-size: 13px;
      }

      p {
        margin: 5px 0;
        line-height: 1.3em;
      }

      &.label {
        text-align: left;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 12px;
        background: #fafafa;
      }

      @media ${device.tablet} {
        padding: 20px 35px;

        &.label {
          text-align: center;
          font-size: 15px;
        }

        &, p, p a {
          font-size: 14px;
        }
      }
    }

    tr:first-child {
      td {
        border-top-width: 0;
        background: #FFF;
        padding: 10px calc(var(--header-padding) + 5px) 20px;

        &.red-border {
          padding: 10px var(--header-padding) 20px;
        }

        &:not(.red-border) {
          border-left-width: 0;
          border-right-width: 0;
        }
      }
    }

    tr:last-child {
      td {
        border-bottom: 1px solid #D3D5D9;
      }
    }
  }

  .current-prefix {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -2px;
    right: -2px;
    bottom: auto;
    color: #FFF;
    text-align: left;
    font-weight: 700;
    padding: 5px 10px;
    text-transform: uppercase;
    font-size: 13px;
    z-index: 2;
    text-align: center;

    &:not(.empty) {
      background: #C80F05;
    }

    @media ${device.tablet} {
      font-size: 15px;
    } 
    /* font-style: italic; */
  }
`;